import { supabase } from './client';

// COA index-page queries (Phase H). Both views are public — the batches
// and profiles rows they surface are already public via RLS, so no
// additional auth gate beyond the migration 0016/0025 defaults.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = supabase as any;

export type RecentCOA = {
  id: string;
  batch_number: string;
  verified_at: string;
  expires_at: string | null;
  strain: {
    id: string;
    name: string;
    brand: string;
    slug: string;
  };
};

export async function fetchRecentCOAs(limit = 20): Promise<RecentCOA[]> {
  const { data, error } = await db
    .from('batches')
    .select(
      'id, batch_number, verified_at, expires_at, strain:strains(id, name, brand, slug)',
    )
    .eq('review_state', 'approved')
    .not('verified_at', 'is', null)
    .order('verified_at', { ascending: false })
    .limit(limit);
  if (error) throw error;
  return (data ?? []) as RecentCOA[];
}

export type CoaContributor = {
  profile_id: string;
  username: string | null;
  approved_coa_count: number;
};

export async function fetchCoaLeaderboard(limit = 20): Promise<CoaContributor[]> {
  const { data, error } = await db
    .from('v_coa_contributors')
    .select('profile_id, username, approved_coa_count')
    .order('approved_coa_count', { ascending: false })
    .limit(limit);
  if (error) throw error;
  return (data ?? []) as CoaContributor[];
}
